import { Divider, Fab, Grid, IconButton, TextField, Typography } from '@mui/material'
import React from 'react'
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { deleteExtra } from '../../services/apis';

export const ArticulosExtra = ({ extras, setExtras, nuevoExtra, setNuevoExtra, idTarea, deleteExtraApi = deleteExtra, borrarLocalmente = false, compacto = false }) => {

    const crearExtra = () => {
        if (nuevoExtra.descripcion.length > 0 && nuevoExtra.precio > 0) {
            setExtras(prevExtras => [...prevExtras, { ...nuevoExtra }]);
            setNuevoExtra({
                descripcion: '',
                precio: 0
            })
        }
    }

    const borrarExtra = (index, id) => {
        if (borrarLocalmente) {
            setExtras(prevExtras => {
                return prevExtras.filter((_, i) => i !== index);
            });

            if (id) {
                borraExtraBackend(id, false);
            }

            return;
        }

        if (id) {
            borraExtraBackend(id, true);

        } else {
            // Borrar por índice
            setExtras(prevExtras => {
                return prevExtras.filter((_, i) => i !== index);
            });
        }
    }

    const borraExtraBackend = async (id, actualizarEstado = true) => {
        try {
            const response = await deleteExtraApi(id, idTarea);
            console.log(response);

            if (actualizarEstado && response?.success) {
                setExtras(response.data)
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }


    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            xs={12}
            sx={{ mt: compacto ? 1 : 2 }}
        >
            <Grid item xs={12}>
                <Typography variant={compacto ? 'subtitle1' : 'h6'} sx={{ textAlign: 'left', fontWeight: compacto ? 700 : undefined }}>
                    Articulos extra
                </Typography>
            </Grid>

            <Divider variant="middle" color='#aaaaaa' sx={{ minWidth: '100%', mb: compacto ? 1 : 2 }} />

            <Grid
                container
                direction="row"
                justifyContent="start"
                alignItems="center"
                xs={12}
                gap={compacto ? 1 : 2}
            >
                <Grid item xs={compacto ? 7 : 4}>
                    <TextField
                        label="Añadir un extra..."
                        variant="filled"
                        fullWidth
                        size={compacto ? 'small' : 'medium'}
                        name="item"
                        id='product'
                        type='text'
                        value={nuevoExtra.descripcion}
                        onChange={(event) => setNuevoExtra({ ...nuevoExtra, descripcion: event.target.value })}
                    />
                </Grid>

                <Grid item xs={compacto ? 3 : 4}>
                    <TextField
                        label="Precio"
                        variant="filled"
                        fullWidth
                        size={compacto ? 'small' : 'medium'}
                        name="precio"
                        id='price'
                        type='number'
                        value={nuevoExtra.precio}
                        onChange={(event) => {
                            setNuevoExtra({ ...nuevoExtra, precio: event.target.value })
                        }}
                    />
                </Grid>

                <Fab size={compacto ? 'small' : 'large'} color="primary" onClick={() => crearExtra()}>
                    <AddIcon />
                </Fab>
                <Grid item xs={12}>
                    <Divider variant="middle" color='#aaaaaa' sx={{ minWidth: '10%' }} />

                </Grid>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    xs={12}
                    gap={1}
                    sx={{ maxHeight: '30vh', overflow: 'auto', p: 1 }}
                >

                    {extras.map((ext, index) => (
                        <Grid
                            key={ext.id || index}
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            xs={12}
                            className='articulo-extra'
                            sx={{ p: 1 }}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="start"
                                alignItems="center"
                                xs={'auto'}
                                gap={1}
                            >
                                <IconButton onClick={() => borrarExtra(index, ext.id)}>
                                    <DeleteForeverIcon />
                                </IconButton>
                                <Typography variant='subtitle1'>
                                    {ext.descripcion}
                                </Typography>
                            </Grid>

                            <Typography variant='subtitle1'>
                                Precio: <strong>{ext.precio}€</strong>
                            </Typography>
                        </Grid>
                    ))}

                </Grid>
            </Grid>
        </Grid>

    )
}
